/**
 * Quick Pay endpoint overrides — public (no auth required).
 *
 * These endpoints are injected into `publicApi` (unauthenticated).
 * Types are imported from the auto-generated `entitlementsApi.ts`.
 */

import type {
  CreatePaymentSessionApiArg,
  CreatePaymentSessionApiResponse,
  GetPaymentDetailsApiArg,
  GetPaymentDetailsApiResponse,
  SearchAccountInvoiceApiArg,
  SearchAccountInvoiceApiResponse,
  SubmitQuickpayEmailApiArg,
  SubmitQuickpayEmailApiResponse,
} from './entitlementsApi';
import { publicApi } from './publicApi';

const quickPayApi = publicApi.enhanceEndpoints({
  addTagTypes: ['quickpay-controller'],
});

const quickPayEndpoints = quickPayApi.injectEndpoints({
  endpoints: (build) => ({
    createPaymentSession: build.mutation<
      CreatePaymentSessionApiResponse,
      CreatePaymentSessionApiArg
    >({
      query: (queryArg) => ({
        url: '/quickpay/2026-05-05/payments/sessions',
        method: 'POST',
        body: queryArg.createPaymentSessionRequest,
      }),
      invalidatesTags: ['quickpay-controller'],
    }),
    submitQuickPayEmail: build.mutation<
      SubmitQuickpayEmailApiResponse,
      SubmitQuickpayEmailApiArg
    >({
      query: (queryArg) => ({
        url: '/quickpay/2026-05-05/email',
        method: 'POST',
        body: queryArg.submitQuickpayEmailRequest,
      }),
      invalidatesTags: ['quickpay-controller'],
    }),
    getPaymentDetails: build.query<
      GetPaymentDetailsApiResponse,
      GetPaymentDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/quickpay/2026-05-05/payments/${queryArg.paymentId}`,
      }),
      providesTags: ['quickpay-controller'],
    }),
    searchAccountInvoice: build.query<
      SearchAccountInvoiceApiResponse,
      SearchAccountInvoiceApiArg
    >({
      query: (queryArg) => ({
        url: `/quickpay/2026-05-05/accounts/${queryArg.accountNumber}/invoices/${queryArg.invoiceNumber}`,
      }),
      providesTags: ['quickpay-controller'],
    }),
  }),
});

export const {
  useCreatePaymentSessionMutation,
  useSubmitQuickPayEmailMutation,
  useGetPaymentDetailsQuery,
  useLazyGetPaymentDetailsQuery,
  useSearchAccountInvoiceQuery,
  useLazySearchAccountInvoiceQuery,
} = quickPayEndpoints;
